// extracted by mini-css-extract-plugin
export default {"app":"App_app__RszA8","main":"App_main__Ai6bW","footer":"App_footer__tF7ML"};